var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrong_info"},[_c('van-overlay',{attrs:{"show":_vm.infoShow},on:{"click":function($event){$event.stopPropagation();}}},[_c('div',{staticClass:"msg"},[_vm._v(_vm._s(_vm.infoMsg))])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }